import api from '../services/api';

// Areas API functions
export const getAreas = async () => {
  try {
    const response = await api.get('/areas');
    return response.data;
  } catch (error) {
    console.error('Error fetching areas:', error);
    throw error;
  }
};

export const createArea = async (areaData) => {
  try {
    const response = await api.post('/areas', areaData);
    return response.data;
  } catch (error) {
    console.error('Error creating area:', error);
    throw error;
  }
};

export const getAreaById = async (id) => {
  try {
    const response = await api.get(`/areas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching area:', error);
    throw error;
  }
};

export const getAreaForEdit = async (id) => {
  try {
    const response = await api.get(`/areas/edit/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching area for edit:', error);
    throw error;
  }
};

export const updateArea = async (areaData) => {
  try {
    const response = await api.post('/areas/update', areaData);
    return response.data;
  } catch (error) {
    console.error('Error updating area:', error);
    throw error;
  }
};

export const deleteArea = async (id, name = '') => {
  try {
    const response = await api.delete(`/areas/${id}?name=${encodeURIComponent(name)}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting area:', error);
    throw error;
  }
};

export const importAreas = async () => {
  try {
    const response = await api.post('/areas/import');
    return response.data;
  } catch (error) {
    console.error('Error importing areas:', error);
    throw error;
  }
};

export const getCreateAreaData = async () => {
  try {
    const response = await api.get('/areas/create');
    return response.data;
  } catch (error) {
    console.error('Error fetching create area data:', error);
    throw error;
  }
};
